import React from "react";
import { ActionCardProps } from "./types";
import styles from "./ActionCard.module.css";

export const ActionCard: React.FC<ActionCardProps> = ({
  template,
  onClick,
}) => {
  const handleClick = () => {
    onClick(template);
  };

  return (
    <button
      type="button"
      data-testid="action-card"
      className={styles.templateCard}
      onClick={handleClick}
      aria-label={`${template.title} - ${template.description}`}
      role="listitem"
    >
      <h3 className={styles.templateTitle}>{template.title}</h3>
      <p className={styles.templateDescription}>{template.description}</p>
    </button>
  );
};
